import { useEffect, useState } from 'react'
import { useBlocker } from 'react-router'

type NavigationPromptProps = {
  when: boolean
  children: (props: {
    isActive: boolean
    onConfirm: () => void
    onCancel: () => void
  }) => React.ReactNode
  onConfirm: () => void
}

export const NavigationPrompt = ({
  when,
  children,
  onConfirm,
}: NavigationPromptProps) => {
  const [show, setShow] = useState(false)
  const blocker = useBlocker(when && !show)

  useEffect(() => {
    if (blocker.state === 'blocked') {
      setShow(true)
    }
  }, [blocker])

  const handleConfirm = () => {
    setShow(false)
    blocker.proceed?.()
    onConfirm()
  }

  const handleCancel = () => {
    setShow(false)
    blocker.reset?.()
  }

  if (!show) return null

  return (
    <>
      {children({
        isActive: true,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
      })}
    </>
  )
}
